import { Injectable } from '@angular/core'



import { GovernTenantCategoryFormDto, FindGovernTenantCategoryDto, GovernTenantCategoryDto } from '../../dto/governance-admin/tenant-category.dto'
import { PageResultDto } from '../../dto'

import { HttpService } from '../http.service'
import { ADMIN_API_ENDPOINTS } from '@api/common/api-endpoints'

@Injectable()
export class GovernTenantCategoryApiService {
  constructor(
    private httpService: HttpService
    ) {
  }

  async find(findMallDto?: FindGovernTenantCategoryDto) {
    return await this.httpService.get<PageResultDto<GovernTenantCategoryDto>>(ADMIN_API_ENDPOINTS.OFFLINE_TENANT_CATEGORY, findMallDto);
  }

  async create(createTenantCategoryDto: GovernTenantCategoryFormDto) {
    return await this.httpService.post<GovernTenantCategoryDto>(ADMIN_API_ENDPOINTS.OFFLINE_TENANT_CATEGORY, createTenantCategoryDto)
  }

  async findOne(id: string) {
    return await this.httpService.get<GovernTenantCategoryDto>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_CATEGORY}/${id}`)
  }

  async update(id: string, updateTenantCategoryDto: GovernTenantCategoryFormDto) {
    return await this.httpService.put<Boolean>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_CATEGORY}/${id}`, updateTenantCategoryDto)
  }

  async delete(id: string) {
    return await this.httpService.delete<Boolean>(`${ADMIN_API_ENDPOINTS.OFFLINE_TENANT_CATEGORY}/${id}`)
  }


} 